export const environment = {
	production: false,
	microConfiguraciones: 'https://dev-api-config.juvomos.com/api/v1',
	microSeguridades: 'https://dev-api-auth.juvomos.com/api/v1',
	microOrdenes: 'https://dev-api-ordenes.juvomos.com/api/v1',
	microCuentas: 'https://dev-api-cuentas.juvomos.com/api/v1',
	microDeliverect: 'https://dev-api-deliverect.juvomos.com/api/v1',
	microPagos: 'https://dev-api-pagos.juvomos.com/api/v1',
	microIntegrationMerchantMx: 'https://dev-api-merchant.juvomos.com/api/v1',
	merchantMx: 'https://sandbox.api.mxmerchant.com/checkout/v3/vault',
	microNotificaciones: 'https://dev-api-notificaciones.juvomos.com/api/v1',
	microPerk: 'https://dev-api-perk.juvomos.com/api/v1',
	microFacturacionArgentina: 'https://dev-api-arca.juvomos.com/api/v1',
	microReportes: 'https://dev-api-reportes.juvomos.com/api/v1',
	socket: 'https://dev-api-notificaciones.juvomos.com',

	globalapiKey: 'v3QLTjn9ITFQXmz+W5nzQRZ7Ufoedfrw8xWgX',
	firebaseConfig: {
		apiKey: 'AIzaSyAWqTOwkOtTELjAXNuTwINjspKfRCzV1AI',
		authDomain: 'juvodev.firebaseapp.com',
		databaseURL: 'https://juvodev-default-rtdb.firebaseio.com',
		projectId: 'juvodev',
		storageBucket: 'juvodev.firebasestorage.app',
		messagingSenderId: '804241167527',
		appId: '1:804241167527:web:a6bab8ee67d7c0bd1f3782',
		measurementId: 'G-N6SR2LRRSN',
	},
	// Reemplaza esto con tu VAPID key real generado desde Firebase Console
	// Ve a: Firebase Console > Configuración del proyecto > Cloud Messaging > Web Push certificates
	vapidKey: 'BAjs7cNoPc1sQsUuFG2AiV0T3lbC6tZVRiBzMyfA-6eguVSsTp7ywgWSkJENphRqOCMWP6VHqMYya2PCDcqeyIA',
};
